import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'

import { useModalStore } from '@features/modal'
import { useManagePaymentMethods } from '@features/payment/hooks/useManagePaymentMethods'
import { CustomerPaymentMethodItem } from '@features/payment/lib/types'
import DeleteCardModal from '@features/payment/ui/delete-card-modal/DeleteCardModal'

import Radio from '@shared/ui/radio'

import styles from './styles.module.scss'



export default function CardItem ({
  data,
}: {
  data: CustomerPaymentMethodItem;
}) {
  const { t } = useTranslation('personal')
  const { handleDefault } = useManagePaymentMethods()
  const { openModal } = useModalStore()
  const cardIcons: Record<string, string> = {
    master: 'payments/mastercard',
    visa: 'payments/visa',
  }
  const iconSrc = `/icons/${cardIcons[data?.card ?? ''] ?? 'card'}.svg`

  return (
    <div className={styles.root} key={data?.id as string}>
      <Radio
        onChange={() => handleDefault(data?.id as string)}
        checked={!!data?.isDefault}
      />
      <ReactSVG
        className={classNames(styles.root__icon)}
        wrapper="span"
        src={iconSrc}
      />
      <p>
        {t('payment.card')} ****{data?.last}
      </p>
      <ReactSVG
        className={classNames(styles.root__icon, styles['root__icon--delete'])}
        wrapper="span"
        onClick={() => {
          'payment.delete-card'
          openModal('deleteCard', <DeleteCardModal id={data?.id as string} />, {
            title: t('payment.delete-card'),
          })
        }}
        src="/icons/delete.svg"
      />
    </div>
  )
}
